
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, HostListener, Output, Input, EventEmitter, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Task } from "../../models";
import { DatePipe } from "@angular/common";
import { Broadcaster } from "../../../common/providers/broadcaster.service";
import { takeWhile } from "rxjs/operators";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "vp-task-reminder-dialog",
    template: `
      <div id="vnctask_reminder_dialog" class="vnctask_reminer_dialog mat-elevation-z2 open">
        <div class="task__dialog-header brand-color mat-elevation-z2" layout="row center-center">
          <h4>{{ 'TASK_REMINDER' | translate}}</h4>
          <button id="reminderCloseButton" (click)="hideDialog()" mat-button class="task__dialog-desktop-close-button brand-color mat-button">
            <i class="material-icons">clear</i>
          </button>
        </div>
        <div>
          <div class = "task-reminder-subject">
            <span class="header-text disable-select">{{ 'TASKS' | translate }}</span>
            <span class="header-text disable-select">{{ 'OVERDUE' | translate }}</span>
          </div>
          <div class = "task-reminder-task">
            @for (task of tasks; track task) {
              <div>
                @if (task) {
                  <div (click)="onTaskClick.emit(task); close();">
                    <div class="task-reminder-item">
                      <span class="task-subject disable-select">{{task.subject}}</span>
                      <span class="task-due disable-select">{{ datePipe.transform(task.due_date,"MMM dd yyyy") }}</span>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, TranslatePipe]
})
export class TaskReminderComponent implements OnDestroy {
  private broadcaster = inject(Broadcaster);
  private changerDetectorRef = inject(ChangeDetectorRef);

  private dialogRef = inject<MatDialogRef<TaskReminderComponent>>(MatDialogRef);
  private data = inject<{ tasks?: Task[] }>(MAT_DIALOG_DATA, { optional: true });
  isAlive = true;

  tasks: Task[] = this.data?.tasks ?? [];
  @Output() onTaskClick = new EventEmitter<Task>();
  datePipe: DatePipe = new DatePipe("en");

  constructor() {
    this.broadcaster.on<any>("closeAllMdlDialogs").pipe(takeWhile(() => this.isAlive))
      .subscribe(presence => {
        this.close();
      });
    this.broadcaster.on<any>("hideReminderDialog").pipe(takeWhile(() => this.isAlive))
      .subscribe(presence => {
        this.close();
      });
  }

  public close() {
    this.dialogRef.close();
  }

  @HostListener("keydown.esc")
  public hideDialog(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.isAlive = false;
    (this.onTaskClick as any).unsubscribe();
    this.changerDetectorRef.markForCheck();
  }
}
